<template>
  <div class="progress-indicator">
    <el-steps :active="active" :simple=false finish-status="success" align-center>
      <el-step title="artwork"></el-step>
      <el-step title="animation"></el-step>
      <el-step title="preview"></el-step>
    </el-steps>
    <router-link :to="artworkRoute">
      <div v-if="this.$store.getters.userStepIndex >= 1" style="margin-top: -57px; width: 100px; height: 57px; position: absolute; z-index: 100;"></div>
    </router-link>
    <router-link :to="animationRoute">
      <div v-if="this.$store.getters.userStepIndex >= 2" style="margin-top: -57px; margin-left: 100px; width: 100px; height: 57px; position: absolute; z-index: 100;"></div>
    </router-link>
    <router-link :to="previewRoute">
      <div v-if="this.$store.getters.userStepIndex >= 5" style="margin-top: -57px; margin-left: 200px; width: 100px; height: 57px; position: absolute; z-index: 100;"></div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "progress-indicator",
  computed: {
    active() {
      let steps = ["artwork", "animation", "preview"];
      let currentStep = this.$store.getters.currentStep;
      let index = steps.findIndex(step => step === currentStep.name);
      return index;
    },
    artworkRoute() {
      if (this.$route.params.id) {
        return { name: 'add-artwork-page', params: { id: this.$route.params.id } };
      }
      return { name: 'new-artwork-page' };
    },
    animationRoute() {
      if (this.$route.params.id) {
        return { name: 'add-animation-page', params: { id: this.$route.params.id } };
      }
      return { name: 'new-animation-page' };
    },
    previewRoute() {
      if (this.$route.params.id) {
        return { name: 'artwork-preview-page', params: { id: this.$route.params.id } };
      }
      // For new artworks, preview won't be available until after processing
      return { name: 'new-artwork-page' };
    }
  }
};
</script>

<style lang="stylus">
@import "../styles/variables.styl"

.progress-indicator
  margin: 5px auto 0 auto
  width: 300px;

.el-step__line {
  left: 60% !important;
  right: -38% !important;
  background-color: #B73232 !important;
}

.el-step__icon
  background: transparent !important;

.el-icon-check {
  color: #E95557 !important;
}

.is-success {
  color: #FFF !important;
  border-color: #FFF !important;
}

.is-success > .el-step__line {
  background-color: #FFF !important;
}

.is-success > .el-step__icon {
  background: #FFF !important;
}

.is-process {
  color: #FFF !important;
  border-color: #FFF !important;
}

.is-wait {
  color: #B73232 !important;
  border-color: #B73232 !important;
}

// Mobile: the indicator sits inline to the right of Cancel (see Header.vue) and fills that space.
// Show the step labels at a smaller font. The connector line starts a few px inside each circle;
// filling the active/pending circles with the header colour hides the line where it crosses them
// (the completed circle already has a solid white fill).
@media (max-width: mobile-breakpoint)
  .progress-indicator
    padding-left: 0 !important

  // Space between each circle and its label (they otherwise sit flush against the circle).
  .progress-indicator .el-step__title
    display: block
    font-size: 11px
    line-height: 1.2
    margin-top: 6px

  .progress-indicator .el-step__head.is-process .el-step__icon,
  .progress-indicator .el-step__head.is-wait .el-step__icon
    background: #FF5C5E !important
</style>
